// Takes 2 version strings as input and compares them.
// Returns -1 if version1 < version2
// Returns 0 if version1 = version2
// Returns 1 if version1 > version2
export function compare_versions(version1, version2){
    let version1_split = version1.split(".").map(x => parseInt(x));
    let version2_split = version2.split(".").map(x => parseInt(x));

    if (version1_split.length != version2_split.length){
        throw new Error("Trying to compare versions with a different number of parts.");
    }

    for(let idx = 0; idx < version1_split.length; idx++){
        let version1_part = version1_split[idx];
        let version2_part = version2_split[idx];

        if (version1_part < version2_part){
            return -1;
        }else if(version1_part > version2_part){
            return 1;
        }
    }
    return 0;
}